import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { NodeService } from '../../shared/services/nodeservice.service';
import { Investors } from '../../shared/services/investors';
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";

interface applicationStatus {
    statusName: string;
    value: string;
}

interface applicationOfferStatus {
    offerStatusName: string;
    value: string;
}

@Component({
    selector: 'app-applications-callback',
    templateUrl: './investors.component.html'
})
export class InvestorsComponent implements OnInit {

    loading: boolean;
    files1: Investors[];
    selectedNode1: Investors;

    cols: any[];

    filterForm: FormGroup;
    applicationStatus: applicationStatus[];
    selectedStatus: applicationStatus[];
    status: any;
    applicationOfferStatus: applicationOfferStatus[];
    selectedOfferStatus: applicationOfferStatus[];
    offerStatus: any;

    constructor(private title: Title, private router: Router, private nodeService: NodeService, private fb: FormBuilder) {
        this.title.setTitle('Investors | XYZ Corp. Verification Workspace');

        this.status = [
            { statusName: 'Approved', value: '1' },
            { statusName: 'Pending', value: '2' },
            { statusName: 'Rejected', value: '3' },
            { statusName: 'Suspended', value: '4' }
        ];

        this.offerStatus = [
            { offerStatusName: 'Offers Applied', value: '1' },
            { offerStatusName: 'Offers Registered', value: '2' }
        ];
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.loading = true;
        this.nodeService.getInvestors().then(files => this.files1 = files);

        this.filterForm = this.fb.group({
            'applicationStatus': new FormControl(null),
            'applicationOfferStatus': new FormControl(null),
            'dateFrom': new FormControl(null),
            'dateTo': new FormControl(null),
            'searchText': new FormControl(null),
        });
    }

    setStatusClass(status) {
        switch (status) {
            case 'Approved':
                return 'green';
            case 'Suspended':
                return 'grey';
            case 'Pending':
                return 'blue';
            case 'Rejected':
                return 'red';
        }
    }

    onNavigateBack() {
        this.router.navigate(['investors']);
    }

}
